import React, { useState } from "react";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import { makeStyles, Button, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { i18n } from "../../translate/i18n.js";
import PerfisList from "./PerfisList";
import PerfilModal from "./PerfilModal";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderRadius: 8,
    boxShadow: theme.shadows[1],
    ...theme.scrollbarStyles,
  },
}));

const Perfis = () => {
  const classes = useStyles();
  const [perfilModalOpen, setPerfilModalOpen] = useState(false);
  const [selectedPerfil, setSelectedPerfil] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const handleOpenPerfilModal = () => {
    setSelectedPerfil(null);
    setPerfilModalOpen(true);
  };

  const handleEditPerfil = (perfil) => {
    setSelectedPerfil(perfil);
    setPerfilModalOpen(true);
  };

  const handleDeletePerfil = (perfil) => {
    alert(i18n.t("profiles.deleteAlert", { name: perfil.perf_name }));
  };

  const handleClosePerfilModal = (shouldRefresh) => {
    setPerfilModalOpen(false);
    setSelectedPerfil(null);
    if (shouldRefresh) setRefresh((r) => !r);
  };

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>{i18n.t("mainDrawer.listItems.perfis")}</Title>
        <MainHeaderButtonsWrapper>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenPerfilModal}
          >
            {i18n.t("profiles.buttons.add")}
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <PerfisList onEdit={handleEditPerfil} onDelete={handleDeletePerfil} key={refresh} />
      </Paper>
      <PerfilModal open={perfilModalOpen} onClose={handleClosePerfilModal} perfil={selectedPerfil} />
    </MainContainer>
  );
};

export default Perfis;
